import React from 'react';
import { motion } from 'framer-motion';
type SectionProps = {
  eyebrow?: string;
  title?: string;
  children: React.ReactNode;
  className?: string;
  id?: string;
  center?: boolean;
};
export function Section({
  eyebrow,
  title,
  children,
  className = '',
  id,
  center = false
}: SectionProps) {
  return <section id={id} className={`w-full px-6 py-16 sm:py-20 ${className}`} data-id="element-105" data-mp="3kwjbu6890uf7">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} className={`mx-auto max-w-2xl ${center ? 'text-center' : ''}`} data-id="element-106" data-mp="cf52c679482e">
        {eyebrow && <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#b06a4a]" data-id="element-107" data-mp="7oolec4824ba">
            {eyebrow}
          </p>}
        {title && <h2 className="font-serif text-2xl font-medium leading-snug text-[#3a2e28] sm:text-3xl" data-id="element-108" data-mp="vcy7zg99ew3h">
            {title}
          </h2>}
        <div className={title ? 'mt-6' : ''} data-id="element-109" data-mp="2zkbzxr0ny3rh">{children}</div>
      </motion.div>
    </section>;
}